import { isChannel, LoadMoreButton } from 'stream-chat-react';
import type { SearchResultsListProps } from 'stream-chat-react';

type CustomSearchResultsListProps = SearchResultsListProps & {
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore: () => void;
};

export const SearchResultsList = ({
  results,
  SearchResultItem,
  selectResult,
  focusedUser,
  hasMore,
  isLoadingMore,
  onLoadMore,
}: CustomSearchResultsListProps) => (
  <>
    {results.map((result, index) => (
      <SearchResultItem
        key={isChannel(result) ? result.cid : result.id}
        focusedUser={focusedUser}
        index={index}
        result={result}
        selectResult={selectResult}
      />
    ))}
    {hasMore && <LoadMoreButton onClick={onLoadMore} isLoading={isLoadingMore} />}
  </>
);

export default SearchResultsList;
